import { render, staticRenderFns } from "./RollCall.vue?vue&type=template&id=35e5e5ec&scoped=true"
import script from "./RollCall.vue?vue&type=script&lang=js"
export * from "./RollCall.vue?vue&type=script&lang=js"
import style0 from "./RollCall.vue?vue&type=style&index=0&id=35e5e5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5e5ec",
  null
  
)

export default component.exports